import React from "react";
import PhotoUploadCard from "./PhotoUploadCard";
import Button from "../../../components/ui/Button";

const CivilWorkPhase = ({
  data,
  onUpdate,
  onComplete,
  customerId,
  uploadPhoto,
  isSaving = false,
  isCompleting = false,
  isVerifyingLocation = false,
  overlayMeta = null,
  capturedLocation = null,
}) => {
  const photoId = "mounting_structure";

  const handlePhotoUpload = (photoId, url) => {
    onUpdate({
      ...data,
      photos: {
        ...data?.photos,
        [photoId]: url,
      },
    });
  };

  const handlePhotoRemove = (photoId) => {
    const updatedPhotos = { ...data?.photos };
    delete updatedPhotos?.[photoId];
    onUpdate({
      ...data,
      photos: updatedPhotos,
    });
  };

  return (
    <div className="space-y-6 md:space-y-8">
      <div>
        <PhotoUploadCard
          title="Mounting Structure"
          description="Capture the completed mounting structure."
          photoUrl={data?.photos?.[photoId]}
          onUpload={(url) => handlePhotoUpload(photoId, url)}
          onRemove={() => handlePhotoRemove(photoId)}
          uploadFunction={
            uploadPhoto && customerId
              ? (file) => uploadPhoto(customerId, file, photoId)
              : null
          }
          overlayMeta={overlayMeta}
          capturedLocation={capturedLocation}
        />
      </div>

      <div className="flex flex-wrap gap-2 justify-center sm:justify-end">
        <Button
          variant="success"
          size="lg"
          onClick={onComplete}
          disabled={isSaving || isCompleting}
          loading={isCompleting}
          iconName={isVerifyingLocation ? "MapPin" : "CheckCircle2"}
          iconPosition="left"
        >
          {isVerifyingLocation
            ? "Verifying Location..."
            : "Complete Civil Work"}
        </Button>
      </div>
    </div>
  );
};

export default CivilWorkPhase;
